import type { IconAsset } from '../Icon.types';

const code = (
  <>
    <rect fill='none' height='16' width='16' />
    <g transform='translate(-310.864 -9.25)'>
      <g transform='translate(252.445 -193.917)'>
        <path
          d='M70.737,210.139a8.792,8.792,0,0,1,7.942,5.028h1.377a10.051,10.051,0,0,0-18.637,0H62.8a8.791,8.791,0,0,1,7.941-5.028Z'
          fill='currentColor'
          transform='translate(0 0)'
        />
        <path
          d='M70.737,208.632a10.3,10.3,0,0,1,9.55,6.44.25.25,0,0,1-.232.344H78.679a.25.25,0,0,1-.226-.143,8.589,8.589,0,0,0-3.1-3.525,8.528,8.528,0,0,0-9.241,0,8.589,8.589,0,0,0-3.095,3.525.25.25,0,0,1-.226.143H61.419a.25.25,0,0,1-.232-.344,10.3,10.3,0,0,1,9.55-6.44Zm8.94,6.284a9.8,9.8,0,0,0-17.879,0h.842a9.088,9.088,0,0,1,3.206-3.588,9.028,9.028,0,0,1,9.784,0,9.088,9.088,0,0,1,3.206,3.588Z'
          fill='currentColor'
          transform='translate(0 0)'
        />
        <path
          d='M70.737,517.436a8.791,8.791,0,0,1-7.941-5.028H61.419a10.05,10.05,0,0,0,18.637,0H78.679a8.791,8.791,0,0,1-7.942,5.028Z'
          fill='currentColor'
          transform='translate(0 -297.242)'
        />
        <path
          d='M70.737,518.943a10.3,10.3,0,0,1-9.55-6.441.25.25,0,0,1,.232-.344H62.8a.25.25,0,0,1,.226.143,8.589,8.589,0,0,0,3.095,3.525,8.528,8.528,0,0,0,9.241,0,8.589,8.589,0,0,0,3.1-3.525.25.25,0,0,1,.226-.143h1.377a.25.25,0,0,1,.232.344,10.3,10.3,0,0,1-9.55,6.441ZM61.8,512.658a9.8,9.8,0,0,0,17.879,0h-.842a9.088,9.088,0,0,1-3.206,3.588,9.028,9.028,0,0,1-9.784,0,9.088,9.088,0,0,1-3.206-3.588Z'
          fill='currentColor'
          transform='translate(0 -297.242)'
        />
        <path
          d='M349.594,353.89a3.352,3.352,0,1,0,3.352-3.352A3.352,3.352,0,0,0,349.594,353.89Zm5.447,0a2.095,2.095,0,1,1-2.1-2.1A2.1,2.1,0,0,1,355.041,353.89Z'
          fill='currentColor'
          transform='translate(-282.208 -138.723)'
        />
        <path
          d='M352.946,350.288a3.6,3.6,0,1,1-3.6,3.6A3.606,3.606,0,0,1,352.946,350.288Zm0,6.7a3.1,3.1,0,1,0-3.1-3.1A3.105,3.105,0,0,0,352.946,356.992Zm0-5.447a2.345,2.345,0,1,1-2.345,2.345A2.348,2.348,0,0,1,352.946,351.544Zm0,4.191a1.845,1.845,0,1,0-1.845-1.845A1.847,1.847,0,0,0,352.946,355.735Z'
          fill='currentColor'
          transform='translate(-282.208 -138.723)'
        />
      </g>
    </g>
  </>
);

export const eye: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
